import filter from "lodash/fp/filter";
import find from "lodash/fp/find";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";

import selectUserChoices from "./selectUserChoices";

export default function selectAllCustomisationNotifications(state) {
  const { selectedProductId, formData } = state.app;

  const userChoices = selectUserChoices(state);

  return flow(
    getOr([], ["products"]),
    find(({ id }) => id === selectedProductId),
    getOr([], "customisations"),
    flatMap(getOr([], "notifications")),
    filter((notification) => {
      if (!notification.displayIf) {
        return true;
      }

      return Object.keys(notification.displayIf).some((fieldName) => {
        const { greaterThanOrEqual } = notification.displayIf[fieldName];

        if (!userChoices[fieldName]) {
          return true;
        }

        if (greaterThanOrEqual) {
          return parseFloat(userChoices[fieldName].value) >= greaterThanOrEqual;
        }

        return true;
      });
    })
  )(formData);
}
